import { Col, Form, Input, Row, Select } from "antd";
import { useForm } from "antd/es/form/Form";
import React from "react";
import PayrollYearlySettingsService from "../../Services/PayrollYearlySettingsService";
import { adminContext } from "../../Common/PageRoute";
import { Utils } from "../../Utilities/Utils";
import SAModal from "../../Common/Custom Components/Ant design/SAModal";

const AddPayrollYearlySettings = ({ id, record, onDismiss, selYearOptions }: any) => {
  const [form] = useForm();
  const [loading, setLoading] = React.useState(false);
  const { openNotification } = React.useContext(adminContext);
  //   const [payeAddedYears, setPayeAddedYears] = React.useState<any>();

  return (
    <SAModal
      title={"Add payroll yearly settings"}
      open={true}
      isLoading={loading}
      width={400}
      okText={"Save"}
      cancelText={"Cancel"}
      onCancel={() => onDismiss(false)}
      onOk={() => {
        form.validateFields().then(async (values) => {
          setLoading(true);
          const Id = id ?? 0;
          await PayrollYearlySettingsService.AddPayrollYearlySettings(
            values,
            Id
          ).then((res: any) => {
            console.log(res);
            if (res.status) {
              onDismiss(true);
            } else {
              openNotification("error", res.message);
            }
            setLoading(false);
          });
        }).catch((err) => {
          setLoading(false);
        });
      }}
    >
      {/* requiredMark={false} */}
      <Form form={form} >
        <Row gutter={[10, 10]}>
          <Col span={24}>
            <Form.Item
              className="custom-form-item"
              labelCol={{ span: 24 }}
              wrapperCol={{ span: 24 }}
              rules={[
                {
                  required: true,
                  message: "Please select a year",
                },
              ]}
              label="Year"
              name="yearId"
            >
              <Select
                showSearch
                allowClear
                filterOption={(input, option) =>
                  (option?.label?.toString() ?? "")
                    .toLowerCase()
                    .includes(input.toLowerCase())
                }
                className="select-height-28"
                placeholder="Select year"
                options={selYearOptions}
              />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={[10, 10]}>
          <Col span={24}>
            <Form.Item
              className="custom-form-item"
              labelCol={{ span: 24 }}
              wrapperCol={{ span: 24 }}
              rules={[
                {
                  required: true,
                  message: "Please enter default tax code",
                },
              ]}
              label="Default tax code"
              name="defaultTaxCode"
            >
              <Input
                onKeyPress={(e) => Utils.ValidateCharAndNumberOnly(e)}
                className="line-height-28"
                placeholder="Default tax code"
              />
            </Form.Item>
          </Col>
        </Row>
        {id !== undefined && (
          <Row className="px-3 py-1">
            <Col span={24} className="are-you-sure">
              <Col span={24} style={{ fontWeight: 600, fontSize: 16 }}>
                Are you sure ?
              </Col>
              <Col span={24} style={{ fontSize: 16 }}>
                You want clone details from{" "}
                <span style={{ fontWeight: 700 }}>
                  {1999 + Number(record?.id)} - {2000 + Number(record?.id)}
                </span>
                and add new yearly settings
              </Col>
            </Col>
          </Row>
        )}
      </Form>
    </SAModal>
  );
};

export default AddPayrollYearlySettings;
